module.exports = __webpack_public_path__ + "static/media/active pin.61e60a97.svg";